import { Dispatch, SetStateAction, useMemo, useState, useCallback } from 'react';

export function useToggleState(initial = false): [boolean, Dispatch<SetStateAction<boolean>>, () => void, () => void, () => void] {
    const [state, setState] = useState(initial);
    const [toggleTrue, toggleFalse] = useMemo(() => [true, false].map(value => () => setState(value)), [setState]);
    const invert = useCallback(() => setState(x => !x), []);
    return [state, setState, toggleTrue, toggleFalse, invert];
}